<script lang="ts">
	import { onMount } from "svelte";
    import { redirect } from "@roxi/routify";
	import { DocumentStore } from '$/stores/DocumentStore';
	import DocumentItem from "./DocumentItem.svelte";
    import { TenantStore } from "$/stores/TenantStore";
    import { slide } from "svelte/transition";

	let deleteDocumentId = null;
	let loading = true;

	onMount(async () => {
		if($TenantStore === null) await TenantStore.init();
		await DocumentStore.loadRecent($TenantStore.active.id);

		loading = false;
	});

	const handleShowDeleteDialog = async (id: string) => {
		deleteDocumentId = id;
		await DocumentStore.countDocumentSnippets(deleteDocumentId);
	};
</script>

{#if loading}
	<p class="pdf-recent-loading">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			class="pdf-recent-loading__spinner"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
			/>
		</svg>
		Loading recently uploaded documents...
	</p>

{:else if $DocumentStore?.length}
	<div class="pdf-recent-container" in:slide>
		<h1 class="pdf-recent-header">Recently uploaded:</h1>
		<ul class="pdf-recent-list">
			{#each $DocumentStore as document}
				<DocumentItem
					{document}
					{deleteDocumentId}
					on:openDocument={() => $redirect(`/pdf/${document.id}`)}
					on:showDeleteDialog={() => handleShowDeleteDialog(document.id)}
					on:cancelDelete={() => deleteDocumentId = null}
					on:confirmDelete={async () => await DocumentStore.deleteDocument($TenantStore.active.id, deleteDocumentId)}
				/>
			{/each}
		</ul>
	</div>

{:else}
	<p>No recently uploaded PDFs found.</p>
{/if}

<style>

	.pdf-recent-loading {
		@apply text-gray-400 mt-4 flex flex-row gap-2 items-center;
	}

	.pdf-recent-loading__spinner {
		@apply size-4 animate-spin;
	}
	.pdf-recent-container {
		@apply w-full md:max-w-2xl mt-4;
	}
	.pdf-recent-header {
		@apply text-left text-sm font-normal text-gray-400;
	}
  .pdf-recent-list {
		@apply list-none mt-1;
	}
</style>